var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lh-1 text-center pad30-t result" }, [
    _c("img", {
      staticClass: "icon",
      attrs: { src: require("./img/icon.png") }
    }),
    _c("div", { staticClass: "fb f24 mar30-t" }, [_vm._v("评价完成")]),
    _c("div", { staticClass: "red mar15-t mar40-b" }, [
      _vm._v(_vm._s(_vm.finishMsg))
    ]),
    _c(
      "div",
      { staticClass: "flex justify-center" },
      [
        _c(
          "a",
          { staticClass: "mar20-r", attrs: { href: _vm.origin.VUE_APP_APP } },
          [
            _c("div", { staticClass: "gray6 f16 btn pointer" }, [
              _vm._v("返回商城首页")
            ])
          ]
        ),
        _c(
          "router-link",
          { attrs: { to: "/comment/comment?orderId=" + _vm.orderId } },
          [
            _c("div", { staticClass: "gray6 f16 btn pointer" }, [
              _vm._v("查看评价")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }